import React from "react";

import ArticleList from "../ui/articleList/ArticleList";
import Layout from "../components/Layout";

const ArticleIndexTemplate = (props) => {
  const { pageContext } = props;
  const {
    articles,
    breadcrumb,
    label,
    image,
    alt,
    dbName,
    dbLink,
    filters,
    type,
    description,
    collectionSamples,
  } = pageContext;

  const articleList = (
    <ArticleList
      articles={articles}
      breadcrumb={breadcrumb}
      label={label}
      image={image}
      alt={alt}
      dbName={dbName}
      dbLink={dbLink}
      filters={filters}
      type={type}
      loadMoreText="Load more microPublications..."
      description={description}
      geneModels={collectionSamples && collectionSamples["genemodels"]}
      genomeAnnouncements={collectionSamples && collectionSamples["genomeannouncements"]}
    />
  );

  return <Layout children={articleList} />;
};

export default ArticleIndexTemplate;
